// extracted by mini-css-extract-plugin
module.exports = {"btn":"_Button_btn__1bVIS"};